"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./billingItem.scss");
require("./billingHistory.scss");
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const moment_1 = __importDefault(require("moment"));
const svgIcons_1 = require("../../../../svgIcons");
class BillingItem extends react_1.Component {
    render() {
        const { data } = this.props;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(core_1.Box, { className: "item-case" },
                react_1.default.createElement("div", { className: "item-case-header" },
                    react_1.default.createElement("div", { className: "case-title" }, "Early Bird"),
                    react_1.default.createElement("div", { className: "case-status" },
                        react_1.default.createElement(core_1.Hidden, { mdUp: true },
                            react_1.default.createElement("a", { className: "download-btn", href: data.invoice_pdf },
                                react_1.default.createElement(svgIcons_1.DownloadIcon, null),
                                "PDF")))),
                react_1.default.createElement("div", { className: "item-case-body" },
                    react_1.default.createElement("div", { className: "case-info" },
                        react_1.default.createElement("p", { className: "data-value common-text" },
                            react_1.default.createElement("p", { className: "col" }, "Date:"),
                            react_1.default.createElement("p", { className: "col" }, "Billing Period:"),
                            react_1.default.createElement("p", { className: "col" }, "Amount:")),
                        react_1.default.createElement("p", { className: "data-value common-text data-rows" },
                            react_1.default.createElement("p", null, moment_1.default(data.period_end).format('MM/DD/YYYY').toUpperCase()),
                            react_1.default.createElement("p", null, data.billing_period),
                            react_1.default.createElement("p", null, data.amount)))))));
    }
}
const mapDispatchToProps = (dispatch) => {
    return {};
};
exports.default = react_redux_1.connect(null, mapDispatchToProps)(BillingItem);
